import React, { useState } from "react";
import {
  Card,
  Table,
  Button,
  Row,
  Col,
  message,
  Modal,
  Spin,
  Divider,
  Form,
  Switch,
  Input,
  AutoComplete,
  Avatar,
  Popover,
  InputNumber,
  Tooltip,
} from "antd";

import IntlMessages from "../../../util/IntlMessages";
import ds from "../../../Services/DataServices";
import Skeleton from "react-loading-skeleton";
import { useHistory } from "react-router-dom";
import { useDispatch, useStore, useSelector } from "react-redux";
import { CirclePicker } from "react-color";
import { ChromePicker } from "react-color";
import {
  loadAddCashModalShow,
  loadIsRegistorLoading,
} from "../../../appRedux/actions/Sell";
import {
  ArrowLeftOutlined,
  FireFilled,
  InboxOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { InputGroup } from "reactstrap";
import { FormattedRelativeTime } from "react-intl";
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  StringIsNullOrEmpty,
} from "../../../appRedux/actions/GlobalMethods";
import { setCommonConfigs } from "../../../appRedux/actions/CommonData";
import { SELL_SETTING } from "../../../constants/Pages";
import { BEHAVIOUR_TYPE } from "../../../Services/DataServices";
import { isNumber } from "util";
import ProductSearch from "../../../components/ProductSearch";
import {
  loadQuickLayoutData,
  loadSearchSelectedProduct,
} from "../../../appRedux/actions";
import UploadImage from "../../../components/UploadImage";
import ColorPicker from "../../../components/ColorPicker";
import Beermug from "../../../assets/images/Product-icons/beer-mug.png";
import BuzzTillLogo from "../../../assets/images/buzztill_logo_text_only.png";
import Beer from "../../../assets/images/Product-icons/beer.png";
import Bowlone from "../../../assets/images/Product-icons/bowl-one.png";
import Bowl from "../../../assets/images/Product-icons/bowl.png";
import Cakefive from "../../../assets/images/Product-icons/cake-five.png";
import Cakefour from "../../../assets/images/Product-icons/cake-four.png";
import Cakethree from "../../../assets/images/Product-icons/cake-three.png";
import Cocktail from "../../../assets/images/Product-icons/cocktail.png";
import Cup from "../../../assets/images/Product-icons/cup.png";
import Drink from "../../../assets/images/Product-icons/drink.png";
import Frenchfries from "../../../assets/images/Product-icons/french-fries.png";
import Hamburgerone from "../../../assets/images/Product-icons/hamburger-one.png";
import Hamburger from "../../../assets/images/Product-icons/hamburger.png";
import Hotpot from "../../../assets/images/Product-icons/hot-pot.png";
import Juice from "../../../assets/images/Product-icons/juice.png";
import Pizza from "../../../assets/images/Product-icons/pizza.png";
import Pizza2 from "../../../assets/images/Product-icons/pizza2.png";
import NotAllowedComponent from "../../../components/NotAllowedComponent";

const options = [
  { label: "Automatically Generate a SKU", value: "Apple" },
  { label: "Enter a custom SKU", value: "Pear" },
];
const quickkeysData = [
  {
    quickKeyLayoutDetailID: "1&&_7878-55b3-44cf-930c-b0bb0cdb45ca",
    label: "Standard Product April 05 Custom Wording  Update",
    colorID: 0,
    isShowImages: false,
    displaySeqNo: 0,
    isFolder: false,
    folderName: "",
    isChild: false,
    productID: "174&&_1b9a-c1f7-4077-b83b-b31f8355885a",
    colorCode: "#f49b8c",
    isFolderProduct: false,
  },
  {
    quickKeyLayoutDetailID: "2&&_a312-831d-440d-9c8c-e4c160a8b28a",
    label: "",
    colorID: 0,
    isShowImages: false,
    displaySeqNo: 1,
    isFolder: true,
    folderName: "Folder 1 - Tshirts Update",
    isChild: false,
    productID: "0&&_1b9a-c1f7-4077-b83b-b31f8355885a",
    colorCode: "#f49b8c",
    isFolderProduct: false,
  },
  {
    quickKeyLayoutDetailID: "3&&_6972-8f1a-464d-8aab-1de9d271ccbf",
    label: "Product With Variant  7PM April 7 (Green/Large/Linen) Update",
    colorID: 0,
    isShowImages: false,
    displaySeqNo: 0,
    isFolder: false,
    folderName: "Folder 1 - Tshirts Update",
    isChild: false,
    productID: "228&&_1b9a-c1f7-4077-b83b-b31f8355885a",
    colorCode: "#678e98",
    isFolderProduct: true,
  },
  {
    quickKeyLayoutDetailID: "4&&_eaf5-2bf2-4be0-971c-3063a05a0457",
    label: "Product With Variant  7PM April 7 (Blue/Large/Linen) Update",
    colorID: 0,
    isShowImages: false,
    displaySeqNo: 1,
    isFolder: false,
    folderName: "Folder 1 - Tshirts Update",
    isChild: false,
    productID: "229&&_1b9a-c1f7-4077-b83b-b31f8355885a",
    colorCode: "#678e98",
    isFolderProduct: true,
  },
  {
    quickKeyLayoutDetailID: "5&&_d34a-0269-4194-b744-bd389df69da4",
    label: "Standard Product Ui 2 (Green/Cloth/Csdsd) Update",
    colorID: 0,
    isShowImages: false,
    displaySeqNo: 2,
    isFolder: false,
    folderName: "",
    isChild: false,
    productID: "265&&_1b9a-c1f7-4077-b83b-b31f8355885a",
    colorCode: "#99c8d4",
    isFolderProduct: false,
  },
  {
    quickKeyLayoutDetailID: "11&&_12fe-9cf9-45e8-8978-0894b35a0f44",
    label: "Product With Variant 14-04-2021 (Blue/sdsddf/fgh)",
    colorID: 0,
    isShowImages: false,
    displaySeqNo: 3,
    isFolder: false,
    folderName: "",
    isChild: false,
    productID: "278&&_1b9a-c1f7-4077-b83b-b31f8355885a",
    colorCode: "#99c8d4",
    isFolderProduct: false,
  },
];
const quickColors = [
  {
    colorID: "1&&_9efa-1ea9-4faf-88ed-a48e65b46643",
    colorName: "Red",
    colorCode: "#d77173",
  },
  {
    colorID: "2&&_3c0f-abe8-410d-beca-b45edb8895c8",
    colorName: "Orange",
    colorCode: "#f49b8c",
  },
  {
    colorID: "3&&_e625-bbde-41c4-8dfb-44a4360d0da7",
    colorName: "Yellow",
    colorCode: "#f49b8c",
  },
  {
    colorID: "4&&_4204-e3a8-44bf-93d2-6b4ad58bbba0",
    colorName: "Green",
    colorCode: "#678e98",
  },
  {
    colorID: "5&&_a714-6106-4633-91ea-20960d201e15",
    colorName: "Blue",
    colorCode: "#99c8d4",
  },
  {
    colorID: "6&&_f282-e59f-41f7-b4ac-8ac55cab3c6b",
    colorName: "Purple",
    colorCode: "#aa88b5",
  },
  {
    colorID: "7&&_79b9-e47c-476c-a5ea-f30aee8e5f66",
    colorName: "White",
    colorCode: "#62676f",
  },
];
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 },
  },
};
const QuickLayoutAdd = (match) => {
  const urlQuickKeyID = match.match.params.id;
  const isCopy = match.match.params.iscopy
    ? match.match.params.iscopy == "false"
      ? false
      : match.match.params.iscopy == "true"
      ? true
      : match.match.params.iscopy
    : false;
  const formLayoutName = useSelector(({ MainSale }) => MainSale.formLayoutName);
  //#region UseSelector
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  );
  const getSearchSelectedProduct = useSelector(
    ({ Products }) => Products.searchSelectedProduct
  );
  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  );
  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  );
  //#endregion

  const store = useStore();
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();

  //#region useState

  const [getLayoutData, setLayoutData] = React.useState([]);
  const [options, setOptions] = useState([]);
  const [getSearchProd, setSearchProd] = useState([]);
  const [getQuickkeyCount, setQuickKeyCount] = useState([
    { rows: 5, columns: 5 },
  ]); // we need to use redux approach for this
  const [getQuickKeyColors, setQuickKeyColors] = useState([]);

  const [getMainQuickKeysDetails, setMainQuicKeyDetails] = useState([]);
  const [getQuickKeysDetails, setQuicKeyDetails] = useState([]);
  const [getActiveQuickKeyIndex, setActiveQuickKeyIndex] = useState("7");

  const [getIsFolderOpen, setIsFolderOpen] = useState(false);
  const [getIsActive, setIsActive] = useState(false);
  const [getIsCurrentDragFolder, setIsCurrentDragFolder] = useState("");
  const [getCurrentDragLabel, setCurrentDragLabel] = useState("");
  const [getIsFolderActive, setIsFolderActive] = React.useState(false);
  const [getActiveFolderData, setActiveFolderData] = React.useState([]);

  const [getCurrentDragKey, setCurrentDragKey] = useState("");

  const [getActiveQuickKeyModalData, setActiveQuickKeyModalData] = useState([]);
  const [getActiveQuicKeyModalLabel, setActiveQuicKeyModalLabel] = useState([]);
  const [getActiveQuicKeyModalImageURL, setActiveQuicKeyModalImageURL] =
    useState("");
  const [getActiveQuicKeyModalShowImage, setActiveQuicKeyModalShowImage] =
    useState(true);
  const [getActiveColorCode, setActiveColorCode] = useState("#FF6900");
  const [getActiveColorID, setActiveColorID] = useState("");

  const [isMainLoading, setIsMainLoading] = React.useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [visible, setvisible] = useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isDetailLoading, setIsDetailLoading] = React.useState(true);
  const [getIsDisableCreate, setIsDisableCreate] = useState(true);
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true);
  const [getIsDisableDelete, setIsDisableDelete] = useState(true);
  const [getIsAllowRead, setIsAllowRead] = useState(false);
  const [getAccessLoading, setAccessLoading] = useState(true);
  const [getRights, setRights] = useState([]);
  const [getPermissions, setPermissions] = useState([]);
  const [getCurrData, setCurrData] = useState({
    currencyCode: "",
    currencySymbol: "",
  });
  const [getColorPopOverVisible, setColorPopOverVisible] =
    React.useState(false);
  const [getOutletID, setOutletID] = React.useState("");
  const [getRegID, setRegID] = React.useState("");
  const [imageFiles, setImageFiles] = useState([]);
  const [initialImages, setInitialImages] = useState([]); // Set initial images for editing
  const [getLayoutColorCode, setLayoutColorCode] = useState("#a5b51e");

  //#endregion useState

  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      const commonData = getReduxCommonSetting;
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {};
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData;
        setCurrData(currencyData);
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData);
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData);
          setAccessLoading(false);
        } else {
          toInitialState();
          setAccessLoading(false);
        }
      }
    }

    return () => (mounted = false);
  }, [getReduxCommonSetting]);

  React.useEffect(() => {
    let body = {
      QuickKeyLayoutID: urlQuickKeyID,
    };
    //setQuicKeyDetails(quickkeysData);
    dispatch(setCommonConfigs(SELL_SETTING));
    getQuickLayoutData(body);
    getColors();
    //setQuickKeyColors(quickColors);
  }, []);

  //to set name from mainSale -> service
  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (formLayoutName && formLayoutName != "") {
        form.setFieldsValue({
          LayoutName: formLayoutName,
        });
      }
    }

    return () => (mounted = false);
  }, [formLayoutName]);

  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (getSearchSelectedProduct) {
        onSelect(getSearchSelectedProduct);
      }
    }
    return () => (mounted = false);
  }, [getSearchSelectedProduct]);

  //for selected outlet & register, commmon Data
  React.useEffect(() => {
    if (
      getReduxSelectedStoreOutlets.outlet &&
      getReduxSelectedOutletReg.register
    ) {
      setOutletID(
        getReduxSelectedStoreOutlets.id ? getReduxSelectedStoreOutlets.id : ""
      );
      setRegID(
        getReduxSelectedOutletReg.id ? getReduxSelectedOutletReg.id : ""
      );
    } else {
      let selectedLocalOut = localStorage.getItem("selectedOut");
      let selectedLocalReg = localStorage.getItem("selectedReg");

      if (selectedLocalOut) {
        selectedLocalOut = JSON.parse(selectedLocalOut);

        setOutletID(selectedLocalOut.id);
      }
      if (selectedLocalReg) {
        selectedLocalReg = JSON.parse(selectedLocalReg);
        setRegID(selectedLocalReg.id);
      }
    }
  }, []);

  //for common data -> store currency

  //#region Api Services
  async function getQuickLayoutData(body) {
    await ds
      .getQuickKeyLayouts(body, BEHAVIOUR_TYPE.GET)
      .then((quickKeyLayout) => {
        if (
          quickKeyLayout != null &&
          Array.isArray(quickKeyLayout.data) &&
          quickKeyLayout.data.length != 0
        ) {
          let quickKeyFormData = quickKeyLayout.data;

          if (quickKeyLayout.msgCode === "GENERAL_SUCCESS") {
            let layoutName = isCopy
              ? `Copy of ${quickKeyFormData[0].layoutName}`
              : quickKeyFormData[0].layoutName;
            form.setFieldsValue({
              LayoutName: layoutName,
              DisplaySeqNo: quickKeyFormData[0].displaySeqNo,
            });

            let urls = quickKeyFormData
              .map((data) => data.url)
              .filter((url) => !!url);
            if (urls.length > 0) {
              setInitialImages(urls);
            }

            setIsFolderOpen(quickKeyFormData[0].isSaleFolderOpen);
            setIsActive(quickKeyFormData[0].isActive);

            if (quickKeyFormData[0].colorCode) {
              setLayoutColorCode(quickKeyFormData[0].colorCode);
            }

            setIsLoading(false);
            getQuickLayoutDetailsData(body);
          } else if (quickKeyLayout.msgCode === "GENERAL_ERROR") {
            setIsLoading(false);
            history.push("/Dashboard/sell/settings");
          }
        } else {
          history.push("/Dashboard/sell/settings");
        }
      });
  }
  async function getQuickLayoutDetailsData(body) {
    await ds
      .getQuickKeyLayoutDetails(body, BEHAVIOUR_TYPE.GET)
      .then((quickKeyLayoutDetails) => {
        if (
          quickKeyLayoutDetails != null &&
          Array.isArray(quickKeyLayoutDetails.data) &&
          quickKeyLayoutDetails.data.length != 0
        ) {
          let quickKeyFormData = quickKeyLayoutDetails.data;

          if (quickKeyLayoutDetails.msgCode === "GENERAL_SUCCESS") {
            setMainQuicKeyDetails(quickKeyFormData);

            setQuicKeyDetails(quickKeyFormData);

            let nextDisplaySeqNo = findNextDisplaySeqNo(
              quickKeyFormData,
              false
            );
            nextDisplaySeqNo += 1;
            setActiveQuickKeyIndex(nextDisplaySeqNo);
            setIsDetailLoading(false);
          } else if (quickKeyLayoutDetails.msgCode === "GENERAL_ERROR") {
            setIsDetailLoading(false);
            history.push("/Dashboard/sell/settings");
          }
        } else {
          setActiveQuickKeyIndex(0);
          setIsDetailLoading(false);
        }
      });
  }
  async function getColors() {
    await ds.getColors().then((colors) => {
      if (
        colors != null &&
        Array.isArray(colors.data) &&
        colors.data.length != 0
      ) {
        let colorData = colors.data;

        if (colors.msgCode === "GENERAL_SUCCESS") {
          setQuickKeyColors(colorData);
          setIsDetailLoading(false);
        } else if (colors.msgCode === "GENERAL_ERROR") {
          setIsDetailLoading(false);
          history.push("/Dashboard/sell/settings");
        }
      } else {
        setActiveQuickKeyIndex(0);
        setIsDetailLoading(false);
      }
    });
  }

  async function postQuickKeyLayoutDataServices(body, methodType) {
    const postLayoutData = ds.postQuickKeylayoutData(body, methodType);
    await postLayoutData
      .then((res) => {
        // ;
        if (res && res.length > 0) {
          setIsLoading(false);
          setIsMainLoading(false);
          let body = { QuickKeyLayoutID: "" };
          // getQuickLayoutsListingService(body);
          // message.success(res);
          // here we call quick keys data
          let quickkeyBody = {
            QuickKeyLayoutID: "0&&_85e4-5adf-45c3-a667-c10cfa61c3cesalis",
            OutletID: getOutletID,
            RegisterID: getRegID,
          };
          if (getOutletID != "" && getRegID != "") {
            dispatch(loadQuickLayoutData(quickkeyBody, true));
          }
          history.push("/Dashboard/sell/settings");
        }
      })
      .catch((e) => {
        notAllowMsgCheck(e);
        setIsLoading(false);
        setIsMainLoading(false);
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something went wrong...");
        // }
      });
  }

  const createUpdateQuickkeyLayoutDetails = (values) => {
    let methType = urlQuickKeyID ? BEHAVIOUR_TYPE.UPDATE : BEHAVIOUR_TYPE.POST;
    let quickKeyDetailsData = getIsFolderActive
      ? getMainQuickKeysDetails
      : getQuickKeysDetails;

    let body = {
      BehaviorName: 3,
      QuickKeyLayoutID: isCopy ? "" : urlQuickKeyID,
      LayoutName: values.LayoutName,
      DisplaySeqNo: values.DisplaySeqNo,
      IsSaleFolderOpen: getIsFolderOpen,
      IsCurrentLayout: false,
      IsActive: getIsActive,
      ColorCode: getLayoutColorCode,
      Nodes: quickKeyDetailsData.map((obj) => {
        let isDelete =
          obj.isDeleted != undefined && obj.isDeleted != ""
            ? obj.isDeleted
            : false;
        return {
          QKLD_ID: isCopy
            ? "0&&_85e4-5adf-45c3-a667-c10cfa61c3cesalis"
            : obj.quickKeyLayoutDetailID,
          Label: obj.label,
          FolderName: obj.folderName,
          ProductID: obj.productID,
          ColorID: obj.colorID.toString(),
          ColorCode: obj.colorCode.toString(),
          //ColorID: "3&&_266b-bb8d-4e32-af79-ad98d06d4eb2",
          DisplaySeqNo: obj.displaySeqNo,
          IsFolder: obj.isFolder,
          IsShowImages: obj.isShowImages,
          IsFolderProduct: obj.isFolderProduct,
          BehaviorName: isCopy
            ? 1
            : isDelete
            ? 2
            : obj.BehaviorName != undefined
            ? obj.BehaviorName
            : 3,
          IsDeleted: isDelete,
          Key: isCopy ? getRandomInt(100000000) : obj.key,
          ParentKey: obj.parentKey,
        };
      }),
    };

    const formData = new FormData();
    imageFiles.forEach((file) => {
      formData.append("files", file); // Ensure file is the actual file object
    });

    formData.append("MainData", JSON.stringify(body));
    postQuickKeyLayoutDataServices(formData, methType);
  };

  //#endregion Api Services

  //#region Common Functions

  function setupRightsPermissions(rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights);
    } else {
      setRights([]);
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions);
    } else {
      setPermissions([]);
    }
    if (rpData.read) {
      setIsAllowRead(true);
    } else {
      setIsAllowRead(false);
    }
    if (rpData.create) {
      setIsDisableCreate(false);
    } else {
      setIsDisableCreate(true);
    }
    if (rpData.update) {
      setIsDisableUpdate(false);
    } else {
      setIsDisableUpdate(true);
    }
    if (rpData.delete) {
      setIsDisableDelete(false);
    } else {
      setIsDisableDelete(true);
    }
  }

  function toInitialState() {
    setRights([]);
    setPermissions([]);
    setIsAllowRead(false);
    setIsDisableCreate(true);
    setIsDisableUpdate(true);
    setIsDisableDelete(true);
    setAccessLoading(true);
  }
  function getRandomInt(max, min = 0) {
    return Math.floor(Math.random() * (max - min + 1)) + min; // eslint-disable-line no-mixed-operators
  }
  function getDecryptID(id) {
    return id.substring(0, id.indexOf("&"));
  }
  function removeSpacewithLowerCaseString(name) {
    return name != undefined && name != ""
      ? name.toString().toLocaleLowerCase().trim().replaceAll(/\s/g, "")
      : "";
  }
  function findNextDisplaySeqNo(jsonArray, isFolderActive) {
    return largestNumberinArray(
      jsonArray
        .filter((e) =>
          isFolderActive
            ? e.isFolder == false || e.isFolderProduct == true
            : e.isFolder == true || e.isFolderProduct == false
        )
        .map((e) => {
          return e.displaySeqNo;
        })
    );
  }
  function largestNumberinArray(arr) {
    let i;
    let max = arr[0];
    for (i = 1; i < arr.length; i++) {
      if (arr[i] > max) max = arr[i];
    }
    return max;
  }
  //#endregion Common Functions

  //#region OnClick Function
  const redirectToListing = () => {
    history.push("/Dashboard/sell/settings");
  };

  const handleClickQuickeyActive = (e, index, data) => {
    let a = data;
    if (data != undefined) {
      if (data.isFolder != true || getIsFolderActive) {
        let name = data.isFolder == true ? data.folderName : data.label;
        setActiveQuickKeyModalData(data);
        setActiveQuicKeyModalLabel(name);
        setActiveQuicKeyModalImageURL(data.imageURL);
        setActiveColorCode(data.colorCode);
        setActiveColorID(data.colorID);
        setActiveQuicKeyModalShowImage(data.isShowImages);
        form.setFieldsValue({ QuickKeyLabel: name });
        setvisible(true);
      } else if (data.isFolder == true) {
        // ;
        let folderData = getMainQuickKeysDetails.filter(
          (e) => e.isFolder != true && e.parentKey == data.key
        );
        setActiveColorCode(data.colorCode);
        setActiveColorID(data.colorID);
        setQuicKeyDetails(folderData);
        setActiveFolderData(data);
        // ;

        let nextDisplaySeqNo = findNextDisplaySeqNo(folderData, true);
        nextDisplaySeqNo += 1;
        setActiveQuickKeyIndex(nextDisplaySeqNo);
        setQuickKeyCount([{ rows: 5, columns: 5 }]);
        setIsFolderActive(true);
      }
    } else {
      setActiveQuickKeyIndex(index);
    }
  };

  const onFolderCloseClick = () => {
    // ;

    setIsFolderActive(false);
    setActiveFolderData([]);
    setQuicKeyDetails(getMainQuickKeysDetails);
    setQuickKeyCount([{ rows: 5, columns: 5 }]);

    let displaySeqNo =
      findNextDisplaySeqNo(
        getMainQuickKeysDetails.filter((x) => x.isFolderProduct == false),
        false
      ) + 1;
    setActiveQuickKeyIndex(displaySeqNo);
  };
  function onAddClick() {}
  function onDeleteLayoutClick(id) {
    let body = { QuickKeyLayoutID: id, BehaviorName: parseInt(2) };
    postQuickKeyLayoutDataServices(body, BEHAVIOUR_TYPE.DELETE);
  }
  function onRemoveClick() {}
  const handleColorChangeComplete = ({ hex }) => {
    // ;

    setActiveColorCode(hex);
    let colorID = getQuickKeyColors
      .filter(
        (x) =>
          removeSpacewithLowerCaseString(x.colorCode) ===
          removeSpacewithLowerCaseString(hex)
      )
      .map((e) => {
        return e.colorID;
      });
    if (colorID) {
      setActiveColorID(colorID);
    } else {
      //"7&&_a312-831d-440d-9c8c-e4c160a8b28a"
      setActiveColorID("0&&_a312-831d-440d-9c8c-e4c160a8b28a");
    }
  };

  const handleLayoutColorChange = (hex) => {
    setLayoutColorCode(hex);
  };

  //#endregion On Click Functions

  //#region onSelect Functions
  const onSelect = async (selectedObj) => {
    let newProd = [];
    let productID = "";
    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID = selectedObj.productID;
      }
    } else {
      productID = "";
    }
    if (!StringIsNullOrEmpty(productID)) {
      await ds
        .getBookSearchProd(`?productID=${productID}`)
        .then((response) => {
          const productData = response.data;
          if (productData.msgCode == "GENERAL_SUCCESS") {
            if (productData && productData.data.length > 0) {
              newProd = productData.data.map((obj) => {
                return {
                  key: getRandomInt(1000000000000000),
                  ProductID: obj.productID,
                  Name: obj.productName,
                  ImageURL: obj.imageURL,
                };
              });
            }
          }
          if (productData.msgCode == "GENERAL_ERROR") {
            message.error(productData.msgDescription);
          }
        })
        .catch((e) => {
          // console.log("Product Search Issue", e)
        });

      if (newProd && newProd[0] != undefined) {
        let QuickKeyData = {
          quickKeyLayoutDetailID: "0&&_a312-831d-440d-9c8c-e4c160a8b28a",
          label: newProd[0].Name,
          colorID: "7&&_a312-831d-440d-9c8c-e4c160a8b28a", //Set Defualt color ID
          isShowImages: true,
          displaySeqNo: getActiveQuickKeyIndex,
          isFolder: false,
          folderName: getIsFolderActive ? getActiveFolderData.folderName : "",
          isChild: false,
          productID: newProd[0].ProductID,
          imageURL: newProd[0].ImageURL,
          colorCode: "#62676f",
          isFolderProduct: getIsFolderActive ? true : false, //we need to add conditions
          BehaviorName: 1,
          isDeleted: false,
          key: getRandomInt(100000000),
          parentKey: getIsFolderActive ? getActiveFolderData.key : 0,
        };

        let nextDisplaySeqNo = findNextDisplaySeqNo(
          getQuickKeysDetails.concat(QuickKeyData),
          getIsFolderActive
        );
        if (nextDisplaySeqNo < 25) {
          setMainQuicKeyDetails(getMainQuickKeysDetails.concat(QuickKeyData));
          setQuicKeyDetails(getQuickKeysDetails.concat(QuickKeyData));
          nextDisplaySeqNo += 1;
          setActiveQuickKeyIndex(nextDisplaySeqNo);
          setQuickKeyCount([{ rows: 5, columns: 5 }]);
        } else {
          message.error("Kindly select proper index");
        }
        dispatch(loadSearchSelectedProduct([]));
      }
    }
  };

  // const onSelect = (value) => {
  //   let newProd = getSearchProd
  //     .filter((a) => a.productName === value)
  //     .map((obj) => {
  //       return {
  //         key: getRandomInt(1000000000000000),
  //         ProductID: obj.productID,
  //         Name: obj.productName,
  //         ImageURL: obj.imageURL,
  //       };
  //     });
  //   // ;
  //   if (newProd && newProd[0] != undefined) {
  //     let isExist = getQuickKeysDetails.filter(
  //       (x) =>
  //         getDecryptID(x.productID) === newProd[0] &&
  //         getDecryptID(newProd[0].ProductID)
  //     );

  //     // if (isExist.length === 0) {

  //     // } else {
  //     //   message.error("Product is already added in Quick layout");
  //     // }

  //     let QuickKeyData = {
  //       quickKeyLayoutDetailID: "0&&_a312-831d-440d-9c8c-e4c160a8b28a",
  //       label: newProd[0].Name,
  //       colorID: "7&&_a312-831d-440d-9c8c-e4c160a8b28a", //Set Defualt color ID
  //       isShowImages: true,
  //       displaySeqNo: getActiveQuickKeyIndex,
  //       isFolder: false,
  //       folderName: getIsFolderActive ? getActiveFolderData.folderName : "",
  //       isChild: false,
  //       productID: newProd[0].ProductID,
  //       imageURL: newProd[0].ImageURL,
  //       colorCode: "#62676f",
  //       isFolderProduct: getIsFolderActive ? true : false, //we need to add conditions
  //       BehaviorName: 1,
  //       isDeleted: false,
  //       key: getRandomInt(100000000),
  //       parentKey: getIsFolderActive ? getActiveFolderData.key : 0,
  //     };

  //     let nextDisplaySeqNo = findNextDisplaySeqNo(
  //       getQuickKeysDetails.concat(QuickKeyData),
  //       getIsFolderActive
  //     );
  //     if (nextDisplaySeqNo < 25) {
  //       setMainQuicKeyDetails(getMainQuickKeysDetails.concat(QuickKeyData));
  //       setQuicKeyDetails(getQuickKeysDetails.concat(QuickKeyData));
  //       nextDisplaySeqNo += 1;
  //       setActiveQuickKeyIndex(nextDisplaySeqNo);
  //       setQuickKeyCount([{ rows: 5, columns: 5 }]);
  //     } else {
  //       message.error("Kindly select proper index");
  //     }
  //   }
  // };
  //#endregion onSelect Functions

  //#region onSearch Functions
  const handleSearch = async (value) => {
    if (value.length > 1) {
      let nameArray = [];
      let searchProducts = {
        data: {
          msgCode: "",
          msgDescription: "",
        },
      };
      await ds
        .getBookSearchProd(`?keys=${value}`)
        .then((response) => (searchProducts.data = response.data))
        .catch((e) => {
          // console.log("Product Search Issue", e)
        });

      if (searchProducts.data.msgCode == "GENERAL_SUCCESS") {
        if (searchProducts.data.data.length > 0) {
          setSearchProd(getSearchProd.concat(searchProducts.data.data));
          nameArray = searchProducts.data.data.map((names) => {
            const category = names.productName;
            return {
              value: category,
              label: (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span
                    style={{
                      backgroundColor: "lightcyan",
                      fontStyle: "oblique",
                      fontWeight: "bolder",
                    }}
                  >
                    <a>{category}</a>
                  </span>
                  <span>
                    <IntlMessages id="products.addeditpriceprod.searchresult" />
                  </span>
                </div>
              ),
            };
          });
        }
        setOptions(nameArray);
      }

      if (searchProducts.data.msgCode == "GENERAL_ERROR") {
        message.error(searchProducts.data.msgDescription);
      }
    } else {
      setOptions([]);
      setSearchProd([]);
    }
  };
  //#endregion onSearch Functions

  //#region Drag Functions
  function dragStart(event) {
    var label =
      event.currentTarget.getElementsByClassName("dk-quick-key-label")[0] !=
      undefined
        ? event.currentTarget.getElementsByClassName("dk-quick-key-label")[0]
            .innerText
        : "";
    var key =
      event.currentTarget.getElementsByClassName("dk-quick-key-label-key")[0] !=
      undefined
        ? event.currentTarget.getElementsByClassName(
            "dk-quick-key-label-key"
          )[0].innerText
        : "";
    setCurrentDragLabel(label);
    setCurrentDragKey(parseInt(key));
    setIsCurrentDragFolder(event.currentTarget.attributes[0].value);
    event.dataTransfer.setData("Text", event.target.id);
  }

  function drop(event) {
    let currentAttributeObject = event.currentTarget.attributes; //This is the target elements ,jispr object drag hoga

    let displaySeqNo = parseInt(currentAttributeObject.displayseqno.value); //DisplaySequenceNo
    let isFolder = currentAttributeObject.isfolder.value; //isFolder
    let labelName = currentAttributeObject.labelname.value; //labelName
    let key = currentAttributeObject._key.value; //salis

    if (getIsCurrentDragFolder != "true") {
      //One QuickKey Product Drag into another Quickkey Product
      if (isFolder == "false" && labelName != "" && !getIsFolderActive) {
        let parentFolderJson = {
          quickKeyLayoutDetailID: "0&&_a312-831d-440d-9c8c-e4c160a8b28a",
          label: "",
          colorID: "7&&_a312-831d-440d-9c8c-e4c160a8b28a",
          isShowImages: false,
          displaySeqNo: displaySeqNo,
          isFolder: true,
          folderName: "New Folder" + getRandomInt(50),
          isChild: false,
          productID: "0&&_a312-831d-440d-9c8c-e4c160a8b28a",
          colorCode: "#62676f",
          isFolderProduct: false, //we need to add conditions
          BehaviorName: 1,
          isDeleted: false,
          key: getRandomInt(100000000),
          parentKey: 0,
        };

        let parentFolderName = parentFolderJson.folderName;
        let parentKey = parentFolderJson.key;

        //This approach can be modify in efficient way
        let firstQuickKeyProduct = getQuickKeysDetails.filter(
          (e) => e.key == getCurrentDragKey
        ); ///remove kia is folder ki bit k yahan sy remeber
        let SecondtQuickKeyProduct = getQuickKeysDetails.filter(
          (e) => e.key == parseInt(key)
        );

        firstQuickKeyProduct[0].displaySeqNo = 0;
        firstQuickKeyProduct[0].isFolderProduct = true;
        firstQuickKeyProduct[0].folderName = parentFolderName;
        firstQuickKeyProduct[0].parentKey = parentKey;

        SecondtQuickKeyProduct[0].displaySeqNo = 1;
        SecondtQuickKeyProduct[0].isFolderProduct = true;
        SecondtQuickKeyProduct[0].folderName = parentFolderName;
        SecondtQuickKeyProduct[0].parentKey = parentKey;

        setQuicKeyDetails(getQuickKeysDetails.concat(parentFolderJson));
        setMainQuicKeyDetails(getMainQuickKeysDetails.concat(parentFolderJson));
      }
      //One QuickKey Product Drag into Folder
      else if (isFolder == "true" && labelName != "" && !getIsFolderActive) {
        let firstQuickKeyProduct = getQuickKeysDetails.filter(
          (e) => e.key == getCurrentDragKey
        ); ///remove kia is folder ki bit k yahan sy remeber

        let nextDisplaySeqNoArray = getQuickKeysDetails.filter(
          (e) => e.parentKey == key
        );

        let seqNo = findNextDisplaySeqNo(nextDisplaySeqNoArray, true);
        if (seqNo <= 23) {
          firstQuickKeyProduct[0].displaySeqNo = seqNo + 1;
          firstQuickKeyProduct[0].isFolderProduct = true;
          firstQuickKeyProduct[0].folderName = labelName;
          firstQuickKeyProduct[0].parentKey = key;
          message.success("Product are enter in folder");
        } else {
          message.success("Kindly Select Index");
        }
      }
      //One QuickKey Product Drag into Blank Space
      else if (isFolder == "false" && labelName == "") {
        let quicKeyData = getQuickKeysDetails.filter(
          (e) => e.key == getCurrentDragKey
        );
        let updatedData = quicKeyData;
        updatedData[0].displaySeqNo = displaySeqNo;
        message.success("product Drag into blank space");
      }
    } else {
      //One Folder Drag into Blank Space
      if (isFolder == "false" && labelName == "") {
        let quicKeyData = getQuickKeysDetails.filter(
          (e) => e.isFolder == true && e.key == getCurrentDragKey
        );
        let updatedData = quicKeyData;
        updatedData[0].displaySeqNo = displaySeqNo;
      } else {
        message.error("Not allowed to folder drag on product");
      }
    }

    setQuickKeyCount([{ rows: 5, columns: 5 }]);
    event.preventDefault();
    //var displaySeqNo = event.target.attributes.displayseqno.value;
    var data = event.dataTransfer.getData("Text");
    event.target.appendChild(document.getElementById(data));
  }
  function dragEnter(event) {
    // if (event.currentTarget.classList.contains('droptarget')) {
    //   event.currentTarget.classList.remove('dk-quick-key--blank');
    // }
  }

  function dragLeave(event) {
    ////
    // if ( event.currentTarget.classList.contains('droptarget')) {
    //   event.currentTarget.classList.add('dk-quick-key--blank')
    // //  event.currentTarget.className +=" dk-quick-key--blank";
    // }
  }

  function allowDrop(event) {
    event.stopPropagation();
    event.preventDefault();
    // event.preventDefault();
  }

  //#endregion Drag Functions

  //#region  Components
  const QuickKeys = (props) => {
    // ;
    var totalQuickKeyCount = props.rows * props.columns;
    var quickKeyDetails = getQuickKeysDetails.filter((e) =>
      e.isFolderProduct == getIsFolderActive ? true : false
    );
    return Array.apply(0, Array(totalQuickKeyCount)).map(function (x, i) {
      let data = quickKeyDetails.filter(
        (e) => e.displaySeqNo == i && e.isDeleted == false
      )[0];
      let label =
        data != undefined && data.isFolder != undefined
          ? data.isFolder
            ? data.folderName
            : data.productID != null
            ? data.label
            : ""
          : "";

      let folderProductCount =
        data != undefined && data.isFolder != undefined
          ? data.isFolder
            ? getQuickKeysDetails.filter(
                (e) =>
                  e.isDeleted == false &&
                  e.isFolder == false &&
                  e.parentKey == data.key
              ).length
            : "01"
          : "0";
      return (
        <Col
          xl={4}
          lg={8}
          md={8}
          sm={12}
          xs={24}
          className="gx-col-full add-Quick-keys"
          key={i}
        >
          <div
            className={`dk-quick-key droptarget ${
              i == getActiveQuickKeyIndex
                ? "dk-quick-key--target"
                : "dk-quick-key--hover"
            } ${i} ${
              data != undefined && data.isFolder != undefined
                ? data.isFolder
                  ? "dk-quick-key--folder"
                  : data.productID != null
                  ? ""
                  : "dk-quick-key--blank"
                : "dk-quick-key--blank"
            } custom-hand-active`}
            style={{
              backgroundColor:
                data != undefined && data.isFolder != undefined
                  ? data.isFolder
                    ? data.colorCode
                    : ""
                  : "",
            }}
            onDrop={(e) => drop(e)}
            onDragEnter={(e) => dragEnter(e)}
            onDragLeave={(e) => dragLeave(e)}
            onDragOver={(e) => allowDrop(e)}
            key={i}
            _key={data && data.key ? data.key : ""}
            displayseqno={i}
            isfolder={
              data != undefined && data.isFolder != undefined
                ? data.isFolder.toString()
                : "false"
            }
            labelname={
              data != undefined &&
              data.isFolder != undefined &&
              data.label != undefined
                ? data.isFolder
                  ? data.folderName
                  : data.label
                : ""
            }
            onClick={(e) => handleClickQuickeyActive(e, i, data)}
          >
            {data != undefined && data.isFolder != undefined ? (
              data.isFolder ? (
                <div
                  isfolder={
                    data != undefined && data.isFolder != undefined
                      ? data.isFolder.toString()
                      : "false"
                  }
                  className=""
                  draggable={true}
                  onDragStart={(event) => dragStart(event)}
                  id={"dragMe" + i}
                >
                  <div className="qk-card-head">
                    <span className="float-right">{folderProductCount}</span>
                  </div>
                  <div className="dk-quick-key-card-body">
                    <h3 className="custom-text-center text-color-white dk-quick-key-label">
                      {data.folderName}
                    </h3>
                    <span className="dk-quick-key-label-key custom-div-hide">
                      {data.key}
                    </span>
                  </div>
                </div>
              ) : data.productID != null ? (
                <div
                  isfolder={
                    data != undefined && data.isFolder != undefined
                      ? data.isFolder.toString()
                      : "false"
                  }
                  className="gx-card"
                  draggable={true}
                  onDragStart={(event) => dragStart(event)}
                  id={"dragMe" + i}
                >
                  <div
                    className="qk-card-head"
                    style={{ backgroundColor: data.colorCode }}
                  ></div>
                  <div className="dk-quick-key-card-body">
                    {data.isShowImages &&
                    !StringIsNullOrEmpty(data.imageURL) ? (
                      <div
                        className="dk-quick-key-image"
                        style={{ backgroundImage: `url(${data.imageURL})` }}
                      ></div>
                    ) : (
                      <></>
                    )}
                    <h3 className="custom-text-center dk-quick-key-label">
                      {data.label}
                    </h3>
                    <span className="dk-quick-key-label-key custom-div-hide">
                      {data.key}
                    </span>
                  </div>
                </div>
              ) : (
                <div className=" "></div>
              )
            ) : (
              <div className=" "></div>
            )}
          </div>
        </Col>
      );
    });
  };

  //#endregion Components

  //#region Submission Functions
  const handleOk = (values) => {
    let labelName = values.QuickKeyLabel;

    if (getIsFolderActive && getActiveQuickKeyModalData.isFolder) {
      let quicKeyFolderMainData = getMainQuickKeysDetails.filter(
        (e) => e.isFolder == true && e.key == getActiveFolderData.key
      ); //Update in Main details
      if (quicKeyFolderMainData && quicKeyFolderMainData.length > 0) {
        let folderMainData = quicKeyFolderMainData;
        let isShowImage = getActiveQuicKeyModalShowImage;
        folderMainData[0].folderName = labelName;
        folderMainData[0].colorCode = getActiveColorCode;
        folderMainData[0].colorID = getActiveColorID;
        //updatedData[0].isShowImages = isShowImage;

        let as =
          getQuickKeysDetails &&
          getQuickKeysDetails
            .filter((e) => e.parentKey == getActiveFolderData.key)
            .map((e) => {
              return (e.folderName = labelName);
            });

        let af =
          getMainQuickKeysDetails &&
          getMainQuickKeysDetails
            .filter((e) => e.parentKey == getActiveFolderData.key)
            .map((e) => {
              return (e.folderName = labelName);
            });
      }
    } else {
      let quicKeyMainData = getMainQuickKeysDetails.filter(
        (e) => e.key == getActiveQuickKeyModalData.key
      ); //Update in Main details
      let quicKeyData = getQuickKeysDetails.filter(
        (e) => e.key == getActiveQuickKeyModalData.key
      );
      let isShowImage = getActiveQuicKeyModalShowImage;

      if (quicKeyMainData && quicKeyMainData.length > 0) {
        let updatedMainData = quicKeyMainData;
        updatedMainData[0].label = labelName;
        updatedMainData[0].colorCode = getActiveColorCode;
        updatedMainData[0].colorID = getActiveColorID;
        updatedMainData[0].isShowImages = isShowImage;
      }
      if (quicKeyData && quicKeyData.length > 0) {
        let updatedData = quicKeyData;
        updatedData[0].label = labelName;
        updatedData[0].colorCode = getActiveColorCode;
        updatedData[0].colorID = getActiveColorID;
        updatedData[0].isShowImages = isShowImage;
      }
      setConfirmLoading(false);
      setvisible(false);
    }
    setConfirmLoading(false);
    setvisible(false);
    setQuickKeyCount([{ rows: 5, columns: 5 }]);
  };

  const handleCancel = (values) => {
    setConfirmLoading(false);
    setvisible(false);
    setColorPopOverVisible(false);
  };

  const onFinish = async (values) => {
    setIsMainLoading(true);
    createUpdateQuickkeyLayoutDetails(values);
  };

  const onFinishFailed = (errorInfo) => {
    //let productNameValidation = <IntlMessages id="products.main.add.namemessage" />;
    message.error("Please select layout name");
  };

  const handleDelete = (values) => {
    if (getIsFolderActive && getActiveQuickKeyModalData.isFolder) {
      let quicKeyFolderMainData = getMainQuickKeysDetails.filter(
        (e) => e.isFolder == true && e.key == getActiveFolderData.key
      ); //Update in Main details
      if (quicKeyFolderMainData && quicKeyFolderMainData.length > 0) {
        let folderMainData = quicKeyFolderMainData;
        folderMainData[0].isDeleted = true;

        let af =
          getMainQuickKeysDetails &&
          getMainQuickKeysDetails
            .filter((e) => e.parentKey == getActiveFolderData.key)
            .map((e) => {
              return (e.isDeleted = true);
            });

        let as =
          getQuickKeysDetails &&
          getQuickKeysDetails
            .filter((e) => e.parentKey == getActiveFolderData.key)
            .map((e) => {
              return (e.isDeleted = true);
            });
      }
    } else {
      let quicKeyMainData = getMainQuickKeysDetails.filter(
        (e) => e.key == getActiveQuickKeyModalData.key
      ); //Update in Main details
      let quicKeyData = getQuickKeysDetails.filter(
        (e) => e.key == getActiveQuickKeyModalData.key
      ); //Update  Copy  of Quick  details

      if (quicKeyMainData && quicKeyMainData.length > 0) {
        let updatedMainData = quicKeyMainData;
        updatedMainData[0].isDeleted = true;
      }
      if (quicKeyData && quicKeyData.length > 0) {
        let updatedData = quicKeyData;
        updatedData[0].isDeleted = true;
      }
    }
    setConfirmLoading(false);
    setvisible(false);
    setQuickKeyCount([{ rows: 5, columns: 5 }]);
  };
  //#endregion Submission Functions

  const colorContent = (
    <div className="dk-mgt-3">
      <ChromePicker
        value="#FCB900"
        color={getActiveColorCode}
        className="dk-mg-bt-10"
        onChangeComplete={handleColorChangeComplete}
        popup
      />
      {/* <div className="dk-flex dk-discount-popover-footer dk-pt3 dk-pb3 ">
        <Button
          className="dk-btn-cancel dk-mgr-19"
          type="primary"
          onClick={() => {
            handleOpenChange(false);
          }}
        >
          <IntlMessages id="sell.sell.close" />
        </Button>
      </div> */}
    </div>
  );
  const handleOpenChange = (newOpen) => {
    setColorPopOverVisible(newOpen);
  };

  return getIsAllowRead ? (
    <>
      <div className="Content-wrapper AddQuickKeyLayout-pg">
        <Modal
          className="EditQuickKey-Modal zIndex-change"
          style={{ zIndex: 500 }}
          title={<IntlMessages id="sell.settings.editquickkey" />}
          visible={visible}
          okText={<IntlMessages id="common.resource.save" />}
          cancelText={<IntlMessages id="sell.settings.deletequickkey" />}
          confirmLoading={confirmLoading}
          maskClosable={false}
          onCancel={() => {
            form
              .validateFields()
              .then((values) => {
                handleCancel(values, true);
              })
              .catch((info) => {
                // console.log("Validate info",info)
              });
          }}
          width={700}
          centered={true}
          footer={[
            <Button
              key="back"
              onClick={() => {
                form
                  .validateFields()
                  .then((values) => {
                    handleDelete(values);
                  })
                  .catch((info) => {
                    // console.log("Validate info",info)
                  });
              }}
              className="dk-btn-cancel"
            >
              <IntlMessages id="sell.settings.deletequickey" />
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={confirmLoading}
              onClick={handleCancel}
              className="dk-btn-cancel"
            >
              <IntlMessages id="sell.settings.cancel" />
            </Button>,
            <Button
              key="submit"
              type="primary"
              className="dk-btn-add"
              loading={confirmLoading}
              onClick={() => {
                form
                  .validateFields()
                  .then((values) => {
                    handleOk(values);
                  })
                  .catch((info) => {
                    // console.log("Validate info",info)
                  });
              }}
            >
              <IntlMessages id="sell.settings.save" />
            </Button>,
          ]}
        >
          <Row>
            <Col md={8} className="EditQuickKey-col">
              <div className={"dk-quick-key"}>
                <div className="gx-card" id={"ModalQuickKey"}>
                  <div
                    className="qk-card-head"
                    style={{ backgroundColor: getActiveColorCode }}
                  ></div>
                  <div className="dk-quick-key-card-body">
                    {!StringIsNullOrEmpty(getActiveQuicKeyModalImageURL) &&
                    getActiveQuicKeyModalShowImage ? (
                      <div
                        className="dk-quick-key-image"
                        style={{
                          backgroundImage: `url(${getActiveQuicKeyModalImageURL})`,
                        }}
                      ></div>
                    ) : (
                      <></>
                    )}
                    <h3 className="custom-text-center dk-quick-key-label">
                      {visible ? getActiveQuicKeyModalLabel : ""}
                    </h3>
                    <span className="dk-quick-key-label-key custom-div-hide">
                      {getActiveQuicKeyModalLabel}
                    </span>
                  </div>
                </div>
              </div>
            </Col>

            <Col md={16}>
              <p className="dk-quick-modal-header">
                {getActiveQuickKeyModalData.isFolder == true
                  ? getActiveQuickKeyModalData.folderName
                  : getActiveQuickKeyModalData.label}
              </p>
            </Col>
          </Row>
          <Form
            form={form}
            layout="vertical"
            name="QuickKeyLayoutForm_MODAL"
            initialValues={{
              modifier: "public",
              contactNumberType: "2",
            }}
          >
            <Row>
              <Col md={24} className="p-0">
                <Form.Item
                  name={"QuickKeyLabel"}
                  label={<IntlMessages id="sell.settings.quickkeylabel" />}
                  rules={[
                    {
                      required: true,
                      message: (
                        <IntlMessages id="sell.settings.validationfieldrequired" />
                      ),
                    },
                    {
                      min: 4,
                      message: (
                        <IntlMessages id="sell.settings.minlabelrange" />
                      ),
                    },
                    {
                      max: 100,
                      message: (
                        <IntlMessages id="sell.settings.maxlabelrange" />
                      ),
                    },
                  ]}
                >
                  <Input
                    size="large"
                    onChange={(e) => {
                      setActiveQuicKeyModalLabel(e.target.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>

              {/* gx-alpha-pickers */}
              <div className="mt-4 mb-4">
                <p className="custom-quickkey-modal-text custom-font-color-black ">
                  <IntlMessages id="sell.settings.quickkeycolors" />
                </p>

                <CirclePicker
                  value="#FCB900"
                  colors={getQuickKeyColors.map((e) => {
                    return e.colorCode;
                  })}
                  color={getActiveColorCode}
                  className="circle-picker-custom"
                  onChangeComplete={handleColorChangeComplete}
                />
                <Popover
                  placement="bottom"
                  title={""}
                  content={colorContent}
                  trigger="click"
                  open={getColorPopOverVisible}
                  onOpenChange={handleOpenChange}
                  // overlayClassName="customer-sell-taxpopover"
                >
                  <Button
                    type="primary"
                    className="dk-btn--text-supplementary dk-mg-bt-10"
                  >
                    <IntlMessages id="sell.settings.pickcolor" />
                  </Button>
                </Popover>
              </div>

              <div className="quick-key-layout-list">
                <Switch
                  checked={getActiveQuicKeyModalShowImage}
                  style={{ marginBottom: "20px" }}
                  onChange={(e) => {
                    setActiveQuicKeyModalShowImage(e);
                  }}
                />
                <h3 style={{ lineHeight: "0" }}>
                  <p>
                    <IntlMessages id="sell.settings.showimage" />
                  </p>
                </h3>
              </div>
            </Row>
          </Form>
        </Modal>

        {/* //////////////////// */}

        <Spin
          tip={<IntlMessages id="common.resource.loading" />}
          spinning={isMainLoading}
          size="large"
        >
          <div className="back-arrow-h1">
            <h1 className="d-flex align-items-center">
              <ArrowLeftOutlined
                className="dk-vertical-align"
                onClick={redirectToListing}
              />
              <span className="mx-2">
                {" "}
                {true ? (
                  <IntlMessages id="sell.settings.addquickkeylayout" />
                ) : (
                  <IntlMessages id="sell.settings.editquickkeylayout" />
                )}{" "}
              </span>
            </h1>
          </div>

          <Row className="ant-row dk-row-bg-color m-0 Sec-heading-bg">
            <Col lg={18} md={12} sm={14} xs={24}>
              <p className="title vd-hero-intro custom-font-color-black m-0">
                <IntlMessages id="sell.settings.addquickkeylayoutdescription" />
              </p>
            </Col>

            <Col lg={6} md={12} sm={10} xs={24}>
              <div className="pg-header-btn">
                <Button
                  className="dk-btn-cancel dk-wd-auto"
                  type="primary"
                  onClick={redirectToListing}
                >
                  <IntlMessages id="products.main.add.cancel" />
                </Button>
                {/* {getIsFolderActive ? (
                  <Tooltip title="Please close all the folder, before save.">
                    <Button>
                      <IntlMessages id="products.main.add.save" />
                    </Button>
                  </Tooltip>
                ) : (
                        ""
                 )} */}

                <Button
                  className="dk-btn-add dk-wd-auto"
                  // disabled={isRegistering.isRegistering}
                  form="QuickKeyLayoutForm"
                  htmlType="submit"
                  type="primary"
                  disabled={getIsDisableCreate || getIsDisableCreate} // logic not clear yet define accordingly
                >
                  {true ? (
                    <IntlMessages id="products.main.add.save" />
                  ) : (
                    "Edit Product"
                  )}
                </Button>
              </div>
            </Col>
          </Row>

          <div className="custom-mg-top-25">
            <Spin
              tip={<IntlMessages id="common.resource.loading" />}
              spinning={isLoading}
              size="large"
            >
              <Row>
                <Col lg={6} md={24} sm={24} xs={24}>
                  <h2 className="custom-font-weight-500 custom-font-color-black heading-fonts-adjust">
                    <IntlMessages id="sell.settings.general" />
                  </h2>
                </Col>

                <Col lg={18} md={24} sm={24} xs={24}>
                  <Form
                    {...formItemLayout}
                    form={form}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    initialValues={{
                      prefix: "86",
                    }}
                    className=""
                    scrollToFirstError
                    id="QuickKeyLayoutForm"
                    name="QuickKeyLayoutForm"
                  >
                    <div className="settings-div sd-form-settings">
                      <InputGroup size="large" className="gx-mb-3">
                        <Form.Item
                          className="ant-form-item-label-custom ant-form-margin-right w-100"
                          name="LayoutName"
                          label={<IntlMessages id="sell.settings.layoutname" />}
                          rules={[
                            {
                              required: true,
                              message: (
                                <IntlMessages id="sell.settings.layoutnamemessage" />
                              ),
                            },
                          ]}
                        >
                          <Input placeholder="Quick Key Layout Name" />
                        </Form.Item>
                        <Form.Item
                          className="ant-form-item-label-custom ant-form-margin-right w-100"
                          name="DisplaySeqNo"
                          label={"Display Seq No"}
                          rules={[
                            {
                              required: true,
                              message: "Please enter display seq no",
                            },
                            {
                              type: "number",
                              min: 1, // You can set the minimum value according to your requirements
                              message: "Greater than 0 and should be number",
                            },
                          ]}
                        >
                          <InputNumber placeholder="Display Seq No" />
                        </Form.Item>
                      </InputGroup>

                      <Col lg={24} md={24} sm={24} xs={24} className="p-0 mb-4">
                        <Switch
                          checked={getIsFolderOpen}
                          onClick={(e) => setIsFolderOpen(e)}
                        />
                        <h4 className="mb-0">
                          <IntlMessages id="sell.settings.quickkeybehavior" />
                        </h4>
                        <p className="custom-font-size-15 mb-0">
                          <IntlMessages id="sell.settings.quickkeybehaviordescription" />
                        </p>
                      </Col>

                      <Col lg={24} md={24} sm={24} xs={24} className="p-0 mb-4">
                        <Switch
                          checked={getIsActive}
                          onClick={(e) => setIsActive(e)}
                        />
                        <h4 className="mb-0">Show on Point-of-Sale</h4>
                        <p className="custom-font-size-15 mb-0">
                          Toggle the switch to enable your layouts on sale. You
                          can turn this back on at anytime without losing your
                          settings.
                        </p>
                      </Col>

                      <Col lg={24} md={24} sm={24} xs={24} className="p-0 mb-4">
                        <h4 className="mb-0">Image Upload</h4>
                        <p className="custom-font-size-15 mb-2">
                          Change the Category Menu Background Color according to
                          your preference.
                        </p>
                        <UploadImage
                          setImageFiles={setImageFiles}
                          initialImages={initialImages}
                          multiple={false}
                        />
                      </Col>

                      <Col lg={24} md={24} sm={24} xs={24} className="p-0">
                        <h4 className="mb-0">Background Color</h4>
                        <p className="custom-font-size-15 mb-2">
                          Change the Category Menu Background Color according to
                          your preference.
                        </p>
                        <ColorPicker
                          initialValue={getLayoutColorCode}
                          onChange={handleLayoutColorChange}
                        />

                        <h4 className="mt-2">Preview</h4>
                        <div className="category-menu category-menu-settings">
                          <ul>
                            <li>
                              <a
                                style={{ backgroundColor: getLayoutColorCode }}
                              >
                                {" "}
                                <span>
                                  <img alt="" src={Hotpot} />
                                </span>{" "}
                                Grill Items
                              </a>
                            </li>
                            <li>
                              <a
                                style={{ backgroundColor: getLayoutColorCode }}
                              >
                                {" "}
                                <span>
                                  <img alt="" src={Hamburger} />
                                </span>{" "}
                                Burgers
                              </a>
                            </li>
                            <li>
                              <a
                                style={{ backgroundColor: getLayoutColorCode }}
                              >
                                {" "}
                                <span>
                                  <img alt="" src={Bowl} />
                                </span>{" "}
                                Soups
                              </a>
                            </li>
                          </ul>
                        </div>
                      </Col>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Spin>

            <Divider className="custom-mgt-mgb-35" />

            <Spin
              tip={<IntlMessages id="common.resource.loading" />}
              spinning={isDetailLoading}
              size="large"
            >
              <Row>
                <Col lg={6} md={24} sm={24} xs={24}>
                  <h2 className="custom-font-weight-500 custom-font-color-black heading-fonts-adjust">
                    <IntlMessages id="sell.settings.addproducts" />
                  </h2>

                  <p className="custom-font-size-15">
                    {" "}
                    <IntlMessages id="sell.settings.addproductsdescription" />
                  </p>
                </Col>

                <Col lg={18} md={24} sm={24} xs={24}>
                  <div className="Product-Search-or-Scan col-pad-label">
                    <Form
                      {...formItemLayout}
                      form={form}
                      onFinish={onFinish}
                      onFinishFailed={onFinishFailed}
                      scrollToFirstError
                      id="QuickKeyLayoutForm"
                      name="QuickKeyLayoutForm"
                      className="input-grp"
                    >
                      <ProductSearch isLabel={true} />
                    </Form>
                  </div>
                  {getIsFolderActive ? (
                    <div
                      className="dk-sale-quick-key-folder-header d-flex align-items-center justify-content-between Park-Sale-controller"
                      style={{ backgroundColor: getActiveColorCode }}
                    >
                      <div className="QuickKeysFolderHeadingBar">
                        <span className="edit-btn-header">
                          <i
                            onClick={(e) =>
                              handleClickQuickeyActive(
                                e,
                                0,
                                getActiveFolderData
                              )
                            }
                            className="icon icon-edit dk-quick-key-folder-action dk-quick-key-folder-action--edit custom-hand-active"
                          ></i>
                        </span>
                        <h2 className="mb-0">
                          {" "}
                          {getActiveFolderData.folderName}{" "}
                        </h2>
                      </div>

                      <Button
                        className="d-flex align-items-center justify-content-center"
                        type="primary"
                        onClick={(e) => {
                          onFolderCloseClick();
                        }}
                        icon={<ArrowLeftOutlined />}
                      >
                        Back
                      </Button>
                    </div>
                  ) : (
                    ""
                  )}

                  <Row className="m-0">
                    <QuickKeys
                      rows={getQuickkeyCount[0].rows}
                      columns={getQuickkeyCount[0].columns}
                    />
                  </Row>
                </Col>
              </Row>
            </Spin>
          </div>
        </Spin>
      </div>
    </>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  );
};

export default QuickLayoutAdd;
